export const CHANNELS = {
  google_analytics: {
    id: 'google_analytics',
    name: 'Google Analytics',
    icon: 'google',
    nodes: {
      analytics_report: {
        id: 'analytics_report',
        name: 'Analytics Report',
        icon: 'google',
        requiresConnection: true,
        type: 'report',
        execution: {
          model: 'googleAnalyticsReportAgent',
          prompt: {
            noInput: 'Create a Google Analytics report',
            withInput: 'Create a report based on the following analytics data'
          },
          apiEndpoint: '/googleAnalyticsReportAgent'
        }
      }
    }
  },
  facebook: {
    id: 'facebook',
    name: 'Facebook',
    icon: 'facebook',
    nodes: {
      facebook_post: {
        id: 'facebook_post',
        name: 'Facebook Post',
        icon: 'facebook',
        requiresConnection: true,
        type: 'channel',
        execution: {
          model: 'facebookPostAgent',
          prompt: {
            noInput: 'Create a Facebook post that is engaging and social media friendly',
            withInput: 'Create a Facebook post based on the following content'
          },
          apiEndpoint: '/facebookPostAgent'
        }
      },
      facebook_insights: {
        id: 'facebook_insights',
        name: 'Facebook Insights',
        icon: 'facebook',
        requiresConnection: true,
        type: 'report',
        execution: {
          model: 'facebookInsightsAgent',
          prompt: {
            noInput: 'Create a Facebook insights report',
            withInput: 'Create a report based on the following Facebook insights data'
          },
          apiEndpoint: '/facebookInsightsAgent'
        }
      }
    }
  },
  instagram_page: {
    id: 'instagram_page',
    name: 'Instagram Business Page',
    icon: 'instagram',
    nodes: {
      instagram_page_post: {
        id: 'instagram_post',
        name: 'Instagram post',
        icon: 'instagram',
        requiresConnection: true,
        type: 'channel',
        execution: {
          model: 'instagramPostAgent',
          prompt: {
            noInput: 'Create a Instagram post that is engaging and social media friendly',
            withInput: 'Create a Instagram post based on the following content'
          },
          apiEndpoint: '/instagramPostAgent'
        }
      }
    }
  },
  x: {
    id: 'x',
    name: 'X',
    icon: 'x',
    nodes: {
      x_post: {
        id: 'x_post',
        name: 'X post',
        icon: 'x',
        requiresConnection: true,
        type: 'channel',
      }
    }
  },
  linkedin_page: {
    id: 'linkedin_page',
    name: 'LinkedIn Business Page',
    icon: 'linkedin',
    nodes: {
      linkedin_business_post: {
        id: 'linkedin_business_post',
        name: 'LinkedIn Business post',
        icon: 'linkedin',
        requiresConnection: true,
        type: 'channel',
        execution: {
          model: "linkedinPostAgent",
          prompt: {
            hasInput: "Create a LinkedIn post using the following content: ",
            noInput: "Create a LinkedIn post using the project content brief"
          },
          apiEndpoint: '/feed'
        }
      },
      linkedin_business_article: {
        id: 'linkedin_business_article',
        name: 'LinkedIn Business Article',
        icon: 'linkedin',
        requiresConnection: true,
        type: 'channel',
        execution: {
          model: false,
          prompt: {
            hasInput: "Create a LinkedIn article using the following content: ",
            noInput: "Create a LinkedIn article using the project content brief"
          },
          apiEndpoint: '/articlefeed'
        }
      }
    }
  },
  linkedin_profile: {
    id: 'linkedin_profile',
    name: 'LinkedIn Profile',
    icon: 'linkedin',
    nodes: {
      linkedin_business_post: {
        id: 'linkedin_profile_post',
        name: 'LinkedIn Profile post',
        icon: 'linkedin',
        requiresConnection: true,
        type: 'channel',
        execution: {
          model: "linkedinPostAgent",
          prompt: {
            hasInput: "Create a LinkedIn post using the following content: ",
            noInput: "Create a LinkedIn post using the project content brief"
          },
          apiEndpoint: '/feed'
        }
      },
      linkedin_business_article: {
        id: 'linkedin_profile_article',
        name: 'LinkedIn Profile Article',
        icon: 'linkedin',
        requiresConnection: true,
        type: 'channel',
        execution: {
          model: false,
          prompt: {
            hasInput: "Create a LinkedIn article using the following content: ",
            noInput: "Create a LinkedIn article using the project content brief"
          },
          apiEndpoint: '/articlefeed'
        }
      },
      linkedin_post: {
        name: 'LinkedIn Post',
      }
    }
  },
  wordpress: {
    id: 'wordpress',
    name: 'WordPress',
    icon: 'wordpress',
    nodes: {
      wordpress_post: {
        id: 'wordpress',
        name: 'WordPress',
        icon: 'wordpress',
        requiresConnection: true,
        type: 'channel',
        execution: {
          model: 'wordpressPostAgent',
          prompt: {
            hasInput: "Create a WordPress post using the following content: ",
            noInput: "Create a WordPress post using the project content brief"
          }
        }
      },
    }
  },
  content: {
    id: 'content',
    name: 'Content',
    icon: 'blog',
    nodes: {
      blog_post: {
        id: 'blog_post',
        name: 'Blog Post',
        icon: 'blog',
        requiresConnection: false,
        type: 'channel',
        execution: {
          model: 'wordpressPostAgent',
          prompt: {
            hasInput: "Create a Blog post using the following content: ",
            noInput: "Create a Blog post using the project content brief"
          }
        }
      },
      how_to_guide: {
        id: 'how_to_guide',
        name: 'How To Guide',
        icon: 'question',
        requiresConnection: false,
        type: 'channel',
        execution: {
          model: 'howtoguidePostAgent',
          prompt: {
            hasInput: "Create a How to guide using the following content: ",
            noInput: "Create a How to guide using the project content brief"
          }
        }
      }
    }
  }
  // Add other channels following the same pattern...
};

// Updated helper functions
export const getChannelsList = () => Object.values(CHANNELS);

export const getChannelById = (id) => CHANNELS[id];

// New helper function to get all nodes for a channel
export const getChannelNodes = (channelId) => {
  const channel = CHANNELS[channelId];
  return channel ? Object.values(channel.nodes) : [];
};

// New helper function to check if a node requires connection
export const nodeRequiresConnection = (channelId, nodeId) => {
  const channel = CHANNELS[channelId];
  return channel?.nodes[nodeId]?.requiresConnection || false;
};

// New helper function to check connection restrictions
export const getNodeInboundRestrictions = (channelId, nodeId) => {
  const channel = CHANNELS[channelId];
  return channel?.nodes[nodeId]?.inboundRestrictions || [];
};

// Helper function to get all actions for a channel
export const getChannelActions = (channelId) => {
  const channel = CHANNELS[channelId];
  return channel ? Object.values(channel.childNodes) : [];
}; 